
<template>
  <div class="menuSetting">
    <el-container>
      <el-aside style="width:420px;">
        <div class="menuTitlePanel">
          组织架构
          <img
            @click="delDept"
            src="@/assets/images/common/icon_delete.png"
            v-if="btnAuthorize.delBtn.btnEnable"
          />
          <img
            @click="updDept"
            src="@/assets/images/common/icon_modify.png"
            v-if="btnAuthorize.modifyBtn.btnEnable"
          />
          <img
            @click="addDept"
            src="@/assets/images/common/icon_add.png"
            v-if="btnAuthorize.addBtn.btnEnable"
          />
        </div>
        <el-tree
          ref="deptTree"
          empty-text="暂无数据"
          :expand-on-click-node="true"
          :props="defaultTreeProps"
          :load="loadNode"
          node-key="id"
          @node-click="handleNodeClick"
          highlight-current
          lazy
        >
          <span class="treeNodeTxt" slot-scope="{ node }">
            <img class="treeNodeIcon" src="@/assets/images/common/icon_tree_node.png" />
            <span>{{ node.label }}</span>
          </span>
        </el-tree>
      </el-aside>
      <el-main>
        <div class="btnTitlePanel">组织信息</div>
        <div class="menuDetailPanel">
          <el-form :inline="true" :model="deptDetail" class="form" label-width="150px">
            <el-row v-if="ChangeName">
              <el-col :span="24">
                <el-form-item label="组织名称">
                  <el-input v-model="deptDetail.name" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-else>
              <el-col :span="24">
                <el-form-item label="部门名称">
                  <el-input v-model="deptDetail.name" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="!ChangeName">
              <el-col :span="24">
                <el-form-item label="部门编码">
                  <el-input v-model="deptDetail.code" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24">
                <el-form-item label="排序">
                  <el-input v-model="deptDetail.sort" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="状态">
                  <el-input value="启用" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-main>
    </el-container>
    <!--配置弹窗-->
    <el-dialog
      class="maskBox"
      :visible.sync="isShowMaskBool"
      :title="isShowMaskBox==1?'新增部门信息':'修改部门信息'"
      :close-on-click-modal="false"
    >
      <el-form
        id="addForm"
        :model="addForm"
        :rules="rules"
        inline
        ref="addForm"
        style="text-align: left;"
      >
        <el-row>
          <el-form-item label="部门名称" label-width="180px" prop="name">
            <el-input class="titleSelect" v-model="addForm.name" placeholder="请输入部门名称"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="部门编码" label-width="180px" prop="code">
            <el-input class="titleSelect" v-model="addForm.code" placeholder="请输入编码"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="排序" label-width="180px" prop="sort">
            <el-input-number class="titleSelect" v-model.number="addForm.sort" placeholder="请输入内容" controls-position="right" :controls="false"   :min='1' ></el-input-number>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="状态" label-width="180px">
            <el-select v-model="addForm.status" disabled>
              <el-option
                :label="state.statusName"
                :value="state.status"
                v-for="state in statusList"
                :key="state.status"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="closeBtn">取 消</el-button>
        <el-button type="primary" @click="updateBtn" v-show="isShowMaskBox==2">修改</el-button>
        <el-button type="primary" @click="saveaddBtn" v-show="isShowMaskBox==1">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getDeptService, //部门列表
  addDeptService, //添加部门
  modifyDeptService, //修改部门
  deleteDeptService, //删除部门
  getsubDeptService, //子部门列表
  getDeptListService,
  getGovService //组织列表
} from "../../services/sysSettingService";
export default {
  name: "supplierSetting",
  props: {
    menuCode: {
      type: String
    }
  },
  data() {
    return {
      isShowMaskBool: false,
      isShowMaskBox: 1,
      addForm: {
        name: "", //部门名称
        code:'', //部门编码
        pname: "", //父部门名称
        pid: 0, //父部门id
        sort: 0, //排序
        orgId: 0, //组织id
        status: 1 //状态
      },
      deptDetail: {
        //部门
        level: 1,
        name: "", //部门名称
        code:'', //部门编码
        pname: "", //父部门名称
        pid: 0, //父部门id
        sort: 0, //排序
        orgId: 0, //组织id
        status: 1 //状态
      },
      ChangeName: true,
      selectedNode: {}, //记录选中节点数据
      node: [],
      resolve: [],
      //状态列表
      statusList: [
        { statusName: "禁用", status: 0 },
        { statusName: "启用", status: 1 }
      ],
      rules: {
        name: [
          { required: true, message: "请输入部门名称", trigger: "blur" },
          { min: 1, max: 40, message: "长度在 1 到 40 个字符", trigger: "blur" }
        ],
        code: [
          // { required: true, message: "请输入部门编码", trigger: "blur" },
          { min: 1, max: 20, message: "长度在 1 到 20 个字符", trigger: "blur" }
        ],
        sort: [
           { required: true, message: "请输入排序", trigger: "blur" },
          { type:'number',min: 1, max: 999999999, message: "输入内容长度必须介于1到9之间", trigger:'change'}
        ],
        orgId: [{ required: true, message: "请选择所属组织", trigger: "blur" }]
      },
      formInline: {
        name: ""
      },
      page: 1,
      rows: 10,
      total: null,
      tableData: [],
      GovList: [], //组织列表
      subDeptList: [], //子部门列表
      defaultTreeProps: {
        id: "id",
        label: "name",
        isLeaf: "leaf",
        children: "children"
      },
      selectTableItem: null,
      btnAuthorize: {
        addBtn: { key: "create", btnEnable: false },
        modifyBtn: { key: "update", btnEnable: false },
        delBtn: { key: "delete", btnEnable: false }
      }
    };
  },

  methods: {
    //激活时调用
    onActive(menuCode) {
      this.$getRoleBtns(menuCode, this.btnAuthorize);
      this.matchedName = "";
      // this.getListData();
      // this.getGovListData();
      // this.getsubListData(this.addForm.pid);
    },
    // 加载树结点
    loadNode(node, resolve) {
      this.node = node;
      this.resolve = resolve;
      // 如果是顶级的父节点
      if (node.level === 0) {
        let reqParam = {
          pageIndex: "1",
          pageSize: "50"
        };
        getGovService(reqParam).then(
          res => {
            if (res.code == 10000000) {
              let nodes = res.data;
              nodes.forEach(item => {
                item.level = 1;
              });
              return resolve(nodes);
            } else {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定"
              });
            }
          },
          err => {
            this.$message.error("系统异常");
          }
        );
      } else if (node.level === 1) {
        // 查找顶级对象
        let reqParam = {
          pid: 0,
          orgId: node.data.id
        };
        getDeptListService(reqParam)
          .then(res => {
            if (res.code == 10000000) {
              let nodes = res.data;
              nodes.forEach(item => {
                item.leaf = item.isLeaf == 1;
                item.level = 2;
              });
              return resolve(nodes);
            } else if (res.code >= 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定"
              });
            } else {
              this.$message.error(res.Msg);
            }
          })
          .catch(() => {
            let data = [];
            return resolve(data);
          });
      } else {
        // 根据父节点id找寻下一级的所有节点
        let param = {};
        param.deptId = node.data.id;
        getsubDeptService(param)
          .then(res => {
            if (res.code == 10000000) {
              let nodes = res.data;
              nodes.forEach(item => {
                item.leaf = item.isLeaf == 1;
                item.level = 3;
              });
              return resolve(nodes);
            } else {
              this.$message.error(res.Msg);
            }
          })
          .catch(() => {
            let data = [];
            return resolve(data);
          });
      }
    },
    //获取组织数据列表
    getGovListData() {
      let reqParam = {
        name: this.formInline.name,
        pageIndex: 1,
        pageSize: 100
      };
      getGovService(reqParam).then(
        res => {
          if (res.code == 10000000) {
            // this.total = res.total;
            this.GovList = res.data;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定"
            });
          }
        },
        err => {
          console.log("123");
          this.$alert(err, "提示", {
            confirmButtonText: "确定"
          });
        }
      );
    },
    //获取数据列表
    getListData() {
      let reqParam = {
        name: this.formInline.name,
        pageIndex: this.page,
        pageSize: this.rows
      };
      getDeptService(reqParam).then(
        res => {
          if (res.code == 10000000) {
            this.total = res.total;
            this.tableData = res.data;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定"
            });
          }
        },
        err => {
          console.log("123");
          this.$alert(err, "提示", {
            confirmButtonText: "确定"
          });
        }
      );
    },

    //获取子部门下拉列表数据
    getsubListData(deptId) {
      let reqParam = {
        deptId: deptId
      };
      getsubDeptService(reqParam).then(
        res => {
          if (res.code == 10000000) {
            // this.total = res.total;
            this.subDeptList = res.data;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定"
            });
          }
        },
        err => {
          console.log("123");
          this.$alert(err, "提示", {
            confirmButtonText: "确定"
          });
        }
      );
    },
    /* 菜单点击回调事件 */
    handleNodeClick(Node) {
      if (Node.level > 1) {
        //选中的组织
        this.ChangeName = false;
        this.deptDetail = { ...Node };
        this.selectedNode = Node;
      } else {
        this.ChangeName = true;
        this.selectedNode = Node;
        this.deptDetail.name = Node.name;
        this.deptDetail.sort = 0;
        this.deptDetail.status = "";
      }
      // this.$set()
    },
    /* 按钮点击回调事件 */
    menuBtnClick(btn) {
      this.btnSelected = btn.id;
    },
    /* 菜单新增按钮回调 */
    addDept() {
      var arr = Object.keys(this.selectedNode);
      if (arr.length <= 0) {
        this.$alert("请选择一级组织", "提示");
        return;
      }
      // if (this.deptSelected.id != this.deptSelected.pid) {
      //   this.$alert("最多只能创建二级公司", "提示");
      //   return;
      // }
      this.isShowMaskBox = 1;
      this.isShowMaskBool = true;
      this.addForm = {
        name: "", //部门名称
        pid: 0, //父部门id
        sort: 0, //排序
        orgId: "", //组织
        status: 1 //状态
      };

      if (this.selectedNode.level == 1) {
        this.addForm.orgId = this.selectedNode.id;
      } else {
        this.addForm.pid = this.selectedNode.id;
        this.addForm.orgId = this.selectedNode.orgId;
      }
    },
    /* 新增保存按钮回调 */
    addSave() {
      this.$refs.addForm.validate(res => {
        if (res) {
          this.addDeptReq();
        }
      });
    },
    closeAdd() {
      this.$refs.addForm.resetFields();
      this.isAddDialogShow = false;
    },
    /* 菜单修改按钮回调 */
    updDept() {
      var arr = Object.keys(this.selectedNode);
      if (arr.length <= 1) {
        this.$alert("请选择部门", "提示");
        return;
      }
      if (this.selectedNode.level == 1) {
        this.$alert("不能修改一级组织", "提示");
        return;
      }

      let reqParam = {
        id: this.selectedNode.id
      };
      this.addForm.name = this.selectedNode.name;
      this.addForm.code = this.selectedNode.code;
      this.addForm.pid = this.selectedNode.pid;
      this.addForm.pname = this.selectedNode.pname;
      this.addForm.sort = this.selectedNode.sort;
      this.addForm.id = this.selectedNode.id;
      this.addForm.status = this.selectedNode.status;
      this.addForm.orgId = this.selectedNode.orgId;

      this.isShowMaskBox = 2;
      this.isShowMaskBool = true;
      // this.getsubListData(this.addForm.pid);  //获取子部门下拉框列表
    },
    /* 修改保存按钮回调 */
    updSave() {
      this.$refs.updForm.validate(res => {
        if (res) {
          this.updDeptReq();
        }
      });
    },
    /* 菜单删除按钮回调 */
    delDept() {
      let _this =this
      if (this.selectedNode.level > 1) {
        this.$confirm("确定删除该部门?", "提示", {
          confirmButtonText: "确认"
        }).then(() => {
          let reqParam = {
            deptId: _this.selectedNode.id
          };
          deleteDeptService(reqParam).then(
            res => {
              if (res.code == 10000000) {
                _this.$alert("删除成功", "提示", {
                  confirmButtonText: "确定"
                });
                _this.node.parent.loaded = false
                _this.node.parent.expand()
                _this.loadNode(_this.node, _this.resolve);
                 this.deptDetail ={}
              } else {
                _this.$alert(res.msg, "提示", {
                  confirmButtonText: "确定"
                });
              }
            },
            err => {
              console.log("123");
              this.$alert(err, "提示", {
                confirmButtonText: "确定"
              });
            }
          );
        });
      } else if (this.selectedNode.level == 1) {
        this.$alert("不能删除组织", "提示", {
          confirmButtonText: "确认"
        });
      } else {
        this.$alert("请选择要删除的部门", "提示", {
          confirmButtonText: "确认"
        });
      }
    },
    saveaddBtn() {
      this.$refs["addForm"].validate(valid => {
        if (valid) {
          let reqParam = {
            name: this.addForm.name,
            code: this.addForm.code,
            status: this.addForm.status,
            pid: this.addForm.pid,
            orgId: this.addForm.orgId,
            sort:this.addForm.sort,
          };
          addDeptService(reqParam).then(
            res => {
              if (res.code == 10000000) {
                this.$alert("新增成功", "提示", {
                  confirmButtonText: "确定"
                });
                this.closeBtn();
                let currentNode = this.$refs.deptTree.getCurrentNode();
                let currentNodeIns = this.$refs.deptTree.getNode(
                  currentNode.id
                );
                let parentNode = currentNodeIns.parent;
                parentNode.expanded = false;
                parentNode.loaded = false;
                parentNode.expand();
                // this.loadNode(this.node, this.resolve);
              } else {
                this.$alert(res.msg, "提示", {
                  confirmButtonText: "确定"
                });
              }
            },
            err => {
              console.log("123");
              this.$alert(err, "提示", {
                confirmButtonText: "确定"
              });
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    updateBtn() {
      let _this =this
      if (this.amendLoading) {
        return;
      }
      this.$refs["addForm"].validate(valid => {
        if(valid){
          _this.amendLoading = true;
          let reqParam = {
            id: _this.selectedNode.id,
            name: _this.addForm.name,
            code: _this.addForm.code,
            sort: _this.addForm.sort,
            orgId: _this.addForm.orgId,
            pid: _this.addForm.pid,
            status: _this.addForm.status
          };

          modifyDeptService(reqParam).then(
                  res => {
                    if (res.code == 10000000) {
                      _this.$alert("修改成功", "提示", {
                        confirmButtonText: "确定"
                      });
                      _this.closeBtn();
                      let currentNode = _this.$refs.deptTree.getCurrentNode();
                      let currentNodeIns = _this.$refs.deptTree.getNode(currentNode.id);
                      let parentNode = currentNodeIns.parent;
                      parentNode.expanded = false;
                      parentNode.loaded = false;
                      parentNode.expand();
                        this.deptDetail = { ...reqParam };
                        this.selectedNode={}
                      // _this.loadNode(_this.node,_this.resolve);
                    } else {
                      _this.$alert(res.msg, "提示", {
                        confirmButtonText: "确定"
                      });
                    }
                  },
                  err => {
                    console.log("123");
                    _this.$alert(err, "提示", {
                      confirmButtonText: "确定"
                    });
                  }
          ).finally(err=>{
             _this.amendLoading = false;
          });
        }
      })


    },
    closeBtn() {
      this.amendLoading = false;
      this.isShowMaskBool = false;
      this.addForm.name = "";
      this.addForm.sort = "";
    },
    /* 菜单修改-保存按钮回调 */
    menuSave() {
      if (this.isAddMenu) {
        this.addMenuReq();
      } else {
        this.modifyMenuReq();
      }
    }
  }
};
</script>

<style scoped lang="scss">
.menuSetting {
  height: 100%;
  background-color: #e9f4fa;
  .el-container {
    height: 100%;
    .el-aside {
      padding: 24px;
      background-color: #fff;
      display: flex;
      flex-direction: column;
      .el-tree {
        background-color: #f0f5f7;
        overflow: auto;
        height: 100%;
      }
    }
  }
  /deep/.el-input-number.is-without-controls .el-input__inner{
    text-align: left;
  }
}
.menuDetailPanel {
  text-align: left;
  min-height: 120px;
  padding: 16px 0 0 0;
}
.menuTitlePanel {
  font-size: 18px;
  font-weight: 500;
  text-align: left;
  margin-bottom: 16px;
  img {
    vertical-align: middle;
    float: right;
    margin: 5px 8px 0 0;
  }
}
/deep/.el-input__inner {
  width: 320px;
}
.btnTitlePanel {
  font-size: 14px;
  font-weight: 500;
  text-align: left;
  background-color: #edf8fa;
  padding: 16px;
  margin-bottom: 16px;
}
.el-main {
  margin-left: 16px;
  background-color: #fff;
}
.handlePanel {
  text-align: right;
  // padding: 0 20px;
}
.operatePanel {
  text-align: right;
  margin: 16px 0;
  padding: 0 20px;
}
.el-select {
  width: 100%;
}
.el-form-item__label {
  text-align: left;
}
.addDialog/deep/.el-dialog {
  width: 30%;
}
/deep/.el-radio-button__inner {
  background: #d5e7ed;
  border: none;
  border-radius: 0;
  box-shadow: none;
  :hover {
    background: #069dbc;
    color: #fff;
  }
}
/deep/.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background: #fff;
  color: #069dbc;
  border: none;
  border-radius: 0;
  box-shadow: none;
  :hover {
    background: #069dbc;
    color: #fff;
  }
}
</style>
